import React from 'react';

import './index.scss';


var closeDialogue = (id)=>{

        
    document.getElementById(id).style.display = "none";

}

export default function MSGDialogue(props){
    return (<>
    <div id={props.id}  className={' p-0 msg-diaglogue rounded p-2 position-fixed animate__animated animate__shakeY animate__repeat-1	 ' + props.colors} >
        <span className="position-relative top-0 float-right" onClick={()=>{closeDialogue(props.id)}}>
            <i className='fa fa-close h1 text-white'></i>
        </span>
        <p>
            {props.msg}
        </p>

    </div>
    </>);
}